import getNative from './_getNative';
import root from './_root';

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

export default Map;
